module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: _vm.classes,
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-546248ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/form.vue
// module id = 373
// module chunks = 0